import { getStateCallbacks, type Room } from 'colyseus.js';

/**
 * Narrow, typed view of Colyseus state callbacks for the parts of the state the client uses.
 * The client decodes state by reflection (it does not import the server schema classes), so this
 * module is the single place where the decoded shape is asserted.
 */
export interface CollectionCallbacks<T> {
  onAdd(callback: (item: T, key: string) => void, immediate?: boolean): () => void;
  onRemove(callback: (item: T, key: string) => void): () => void;
}

export interface InstanceCallbacks {
  onChange(callback: () => void): () => void;
}

export interface OfficeStateCallbacks<TPlayer> {
  // Order matters: the specific player overload must come before the `unknown` state overload.
  (instance: TPlayer): InstanceCallbacks;
  (state: unknown): { players: CollectionCallbacks<TPlayer> };
}

export function officeStateCallbacks<TPlayer>(room: Room): OfficeStateCallbacks<TPlayer> {
  return getStateCallbacks(room) as unknown as OfficeStateCallbacks<TPlayer>;
}
